webpackJsonp([117034982319942],{

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	var _FleetBreadcrum = __webpack_require__(31);
	
	var _FleetBreadcrum2 = _interopRequireDefault(_FleetBreadcrum);
	
	var _Fleet = __webpack_require__(20);
	
	var _Fleet2 = _interopRequireDefault(_Fleet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Components
	var Economic_4x4En = function Economic_4x4En(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page economic_4x4' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: ' Economic 4x4 Vehicles for Rent | Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Frequently Asked Questions about car rentals. '
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'en',
	        href: './es/fleet/economic_4x4'
	      }]
	    }),
	    _react2.default.createElement(_FleetBreadcrum2.default, {
	      lang: props.pathContext.langKey,
	      currentPage: 'economic_4x4 Cars'
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      ' Economic 4x4'
	    ),
	    _react2.default.createElement(_Fleet2.default, {
	      lang: props.pathContext.langKey,
	      types: props.data.dataJson.fleetTypes,
	      fleet: props.data.dataJson.fleet,
	      features: props.data.dataJson.fleetFeatures,
	      category: 11
	    })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Economic_4x4En;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fleet-economic-4-x-4-en-js-8d9a5ee591d54e34069d.js